import AdminCreatedMatches from '@commons/matches/admin-created'
import React from 'react'

const AdminCreated = () => {
  return <AdminCreatedMatches isResult={true} />
}

export default AdminCreated
